export default () => ({
  projectId: null,
  isLoading: false,
  errorCode: null,
  mergeRequests: [],
  pageInfo: {},
});
